import { useAuthUrl } from 'features/auth/hooks/useAuthUrl/useAuthUrl';
import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { FeatureFlagKey } from 'services/statsig/types';
import { Headers } from 'shared/constants/headers';
import { getLambdaHeaders } from 'shared/hooks/auth/useLambdaHeaders';
import { z } from 'zod';

export interface ResendOtpData {
  aToken?: string;
  anonymousId: string;
  emailAddress: string;
  phoneNumber: string;
}

export interface ResendOtpChallengeData {
  challengeId: string;
}

// Define schema that matches ResendOtpResponse
const resendOtpResponseSchema = z.object({
  message: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  title: z.string().optional(),
});

// Extract type from schema
export type ResendOtpResponse = z.infer<typeof resendOtpResponseSchema>;

const useResendOtp = () => {
  const authUrl = useAuthUrl(FeatureFlagKey.RESEND_OTP_USE_K8S_AUTH_SERVICE);

  const resendOtp = async (
    data: ResendOtpData | ResendOtpChallengeData,
    headers?: Headers,
  ) => {
    const lambdaHeaders = await getLambdaHeaders();
    const response = await unauthenticatedFetch(`${authUrl}/resend-otp`, {
      method: 'POST',
      cache: 'no-cache',
      body: JSON.stringify({
        ...data,
      }),
      headers: {
        ...lambdaHeaders,
        ...headers,
      },
    });
    const result: unknown = await response.json();

    return resendOtpResponseSchema.parse(result);
  };

  return resendOtp;
};

export default useResendOtp;
